import React, { FC, useMemo } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import classNames from 'classnames'
import { push } from 'connected-react-router'
import { State } from 'index'
import { useDispatch, useSelector } from 'react-redux'
import { Spacer } from 'components/Utility'
import { BlueButton, GreyButton } from 'components/Button'
import { Description, MainHeadline } from 'components/Typography'
import { DepositHistoryCard } from 'components/Card'
import { useQueryShopPayouts } from 'hooks/revenue'
import { getShopRef } from 'reducks/store/selectors'

type Props = {
  payoutId: string
  title: string
}

const DepositHistoryDetailTemplate: FC<Props> = (props) => {
  const { payoutId, title } = props
  const dispatch = useDispatch()
  const shopRef = useSelector((state: State) => getShopRef(state))
  // 残高照会
  const payouts = useQueryShopPayouts(shopRef?.id, 100)
  const payout = useMemo(() => payouts.find((payout) => payout.payoutId === payoutId), [payouts, payoutId])
  const handleBackToList = () => dispatch(push('/account/revenue/deposit_history'))
  const handlePrint = () => dispatch(push(`/account/revenue/deposit_history/print/${payoutId}`))
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={title} />
      <Spacer size={24} />
      {payout && <DepositHistoryCard payout={payout} />}
      <Spacer size={12} />
      <Description description={'入金履歴明細に関するお問い合わせ先'} />
      <a
        className={classNames(text.color_blue_main)}
        href={'mailto:support@sacrisupport.zendesk.com'}
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        support@sacrisupport.zendesk.com
      </a>
      <Spacer size={28} />
      <BlueButton label={'印刷する'} onClick={handlePrint} size={'medium'} type={'main'} />
      <Spacer size={28} />
      <GreyButton label={'入金履歴明細一覧ページに戻る'} onClick={handleBackToList} size={'medium'} type={'outlined'} />
      <Spacer size={72} />
    </div>
  )
}

export default DepositHistoryDetailTemplate
